import { useState, useEffect, useMemo } from 'react';

/**
 * Lazily compute a value once client side rendering has kicked in.
 * Treat this hook like a useMemo.
 * Usage:
 * ```js
 * const displayIsSSR = useLazySSR((ssr) => ssr ? 'Server' : 'Client');
 * const [myValue, setMyValue] = useState(null);
 * const displayMyValue = useLazySSR((ssr) => ssr ? 'Server' : myValue, [myValue]);
 * ```
 * @param {(ssr: Boolean) => any} func
 * @param {Array} deps
 */
const useLazySSR = (func, deps = []) => {
  const [isSsr, setIsSsr] = useState(true);
  useEffect(() => {
    setIsSsr(false);
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const result = useMemo(() => func(isSsr), [func, isSsr, ...deps]);
  return result;
};

export default useLazySSR;
